export interface RubricCriterion {
  key: string;
  label: string;
  description: string;
  maxScore: number;
  guidance: string;
}

export const WRITING_RUBRICS: Record<string, RubricCriterion> = {
  taskAchievement: {
    key: "taskAchievement",
    label: "Adequação à tarefa",
    maxScore: 10,
    description: "Avalia se o texto responde corretamente ao enunciado e cumpre o objetivo comunicativo.",
    guidance: "Verificar se o candidato respeitou a proposta, desenvolveu o tema e manteve foco na tarefa (ex: relatar um fato na Section A ou dar opinião estruturada na Section B)."
  },
  coherence: {
    key: "coherence",
    label: "Coerência e organização",
    maxScore: 10,
    description: "Analisa a estruturação das ideias, divisão em parágrafos e o uso de conectores lógicos.",
    guidance: "Avaliar o fluxo natural do texto, a progressão lógica e a presença de marcadores de transição adequados para conectar orações e parágrafos."
  },
  grammar: {
    key: "grammar",
    label: "Gramática e sintaxe",
    maxScore: 10,
    description: "Avalia a correção gramatical, concordância nominal/verbal, tempos verbais e variedade de estruturas de frases.",
    guidance: "Observar o controle sobre construções simples e complexas, pronomes, preposições e a incidência de erros sistemáticos que possam prejudicar a leitura."
  },
  vocabulary: {
    key: "vocabulary",
    label: "Vocabulário e precisão lexical",
    maxScore: 10,
    description: "Mede a riqueza e a precisão das palavras escolhidas, evitando repetições ou termos vagos.",
    guidance: "Focar na variedade de substantivos, verbos e adjetivos expressivos, além da ausência de termos genéricos (como 'chose', 'faire') ou coloquiais inadequados."
  },
  register: {
    key: "register",
    label: "Registro e naturalidade",
    maxScore: 10,
    description: "Analisa a adequação do tom e do estilo de linguagem ao tipo de texto solicitado.",
    guidance: "Verificar se foi mantido o tom formal ou semiformal exigido na carta (Section B) ou o estilo jornalístico/narrativo de relato (Section A), garantindo a fluidez da redação."
  },
  thoughtDevelopment: {
    key: "thoughtDevelopment",
    label: "Desenvolvimento das ideias",
    maxScore: 10,
    description: "Avalia a profundidade, clareza e originalidade dos argumentos ou da narrativa apresentada.",
    guidance: "Analisar se a história foi devidamente estendida com detalhes lógicos (Section A) ou se os argumentos foram embasados por explicações detalhadas e exemplos pertinentes (Section B)."
  }
};

export const WRITING_RUBRIC_LIST: RubricCriterion[] = Object.values(WRITING_RUBRICS);
